import selectPrescription_en from './select-prescription_en.json'
import selectPrescription_fr from './select-prescription_fr.json'
import selectProduct_en from './select-product_en.json'
import selectProduct_fr from './select-product_fr.json'
import helpGuide_en from './help-guide_en.json'
import helpGuide_fr from './help-guide_fr.json'
import myClaims_en from './myclaim_en.json'
import myClaims_fr from './myclaim_fr.json'
import reviewClaim_en from './review-claim_en.json'
import reviewClaim_fr from './review-claim_fr.json'

const baseCAFlow_resources = {
  en: {
    ...selectPrescription_en,
    ...selectProduct_en,
    ...helpGuide_en,
    ...reviewClaim_en,
    ...myClaims_en,
  },
  fr: {
    ...selectPrescription_fr,
    ...selectProduct_fr,
    ...helpGuide_fr,
    ...reviewClaim_fr,
    ...myClaims_fr,
  },
}

export default baseCAFlow_resources
